import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    iconSection: {
        marginTop: '40px',
        marginBottom: '50px'
    },
    icon: {
        fontSize: 90
    },
    textSection: {
        maxWidth: '80%',
        marginBottom: '60px'
    },
    text: {
        fontSize: 33,
        lineHeight: '1.2em'
    },
    inputSection: {
        width: '80%',
        marginBottom: '30px'
    }
}));

export default useStyles;